var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sale-grid-el"
  }, [_c('div', {
    staticClass: "sale-grid-el__top"
  }, [_c('nuxt-link', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: _vm.image,
      expression: "image",
      arg: "background-image"
    }],
    staticClass: "sale-grid-el__photo",
    attrs: {
      "to": ("/sales/" + (_vm.code) + "/")
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.onClick.apply(null, arguments);
      }
    }
  }), _vm._v(" "), _vm.advertising ? _c('Tooltip', {
    staticClass: "sale-grid-el__tooltip sale-grid-el__tooltip_descktop",
    attrs: {
      "placement": "bottom",
      "width-tool": "100%"
    },
    scopedSlots: _vm._u([{
      key: "handler",
      fn: function () {
        return [_c('div', {
          staticClass: "sale-grid-el__advertising"
        }, [_vm._v("\n          Реклама\n        ")])];
      },
      proxy: true
    }, {
      key: "content",
      fn: function () {
        return [_vm._v("\n        " + _vm._s(_vm.advertising) + "\n      ")];
      },
      proxy: true
    }], null, false, 3615592669)
  }) : _vm._e(), _vm._v(" "), _vm.advertising ? _c('div', {
    staticClass: "sale-grid-el__advertising sale-grid-el__advertising_mobile",
    on: {
      "click": function ($event) {
        _vm.isAdvertising = true;
      }
    }
  }, [_vm._v("\n      Реклама\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "sale-grid-el__bottom"
  }, [_c('div', [_vm.date ? _c('div', {
    staticClass: "sale-grid-el__date"
  }, [_c('span', {
    staticClass: "icon icon_date"
  }), _vm._v("\n        до " + _vm._s(_vm.date) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "sale-grid-el__title"
  }, [_c('nuxt-link', {
    staticClass: "link",
    attrs: {
      "to": ("/sales/" + (_vm.code) + "/")
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.onClick.apply(null, arguments);
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")])], 1), _vm._v(" "), _vm.announcement ? _c('div', {
    staticClass: "sale-grid-el__description"
  }, [_vm._v("\n      " + _vm._s(_vm.announcement) + "\n    ")]) : _vm._e()]), _vm._v(" "), _vm.advertising ? _c('Modal', {
    attrs: {
      "show": _vm.isAdvertising,
      "title": "Информация"
    },
    on: {
      "close": function ($event) {
        _vm.isAdvertising = false;
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.advertising) + "\n  ")]) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }